import { ReactNode, forwardRef } from 'react';

import { useStyles } from './Content.styles';

interface ContentProps {
  children: ReactNode | ReactNode[];
}

export const Content = forwardRef<HTMLDivElement, ContentProps>(
  ({ children }, ref) => {
    const { classes } = useStyles();

    return (
      <div ref={ref} className={classes.content}>
        {children}
      </div>
    );
  },
);
